import { createAsyncThunk } from "@reduxjs/toolkit";
import {
  GetBaseLostReasonsRequest,
  GetBaseLostReasonsResponse,
  CreateBaseLostReasonRequest,
  CreateBaseLostReasonResponse,
  DeleteBaseLostReasonRequest,
  DeleteBaseLostReasonResponse,
  SetProjectLostReasonRequest,
  SetProjectLostReasonResponse,
} from "../../models/Reason.model";
import { environment } from "../../environments";

const API_BASE_URL = environment.apiUrl;

export const getBaseLostReasons = createAsyncThunk<
  GetBaseLostReasonsResponse,
  GetBaseLostReasonsRequest,
  { rejectValue: string }
>(
  "reason/getBaseLostReasons",
  async (requestData, { rejectWithValue }) => {
    try {
      const response = await fetch(`${API_BASE_URL}Reason/GetBaseLostReasons`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(requestData),
      });

      if (!response.ok) throw new Error(`HTTP ${response.status}`);
      const data: GetBaseLostReasonsResponse = await response.json();

      if (!data.success) return rejectWithValue(data.message || "Failed to get base lost reasons");
      return data;
    } catch (error) {
      return rejectWithValue(error instanceof Error ? error.message : "Unknown error");
    }
  }
);

export const createBaseLostReason = createAsyncThunk<
  CreateBaseLostReasonResponse,
  CreateBaseLostReasonRequest,
  { rejectValue: string }
>(
  "reason/createBaseLostReason",
  async (requestData, { rejectWithValue }) => {
    try {
      const response = await fetch(`${API_BASE_URL}Reason/CreateBaseLostReason`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(requestData),
      });

      if (!response.ok) throw new Error(`HTTP ${response.status}`);
      const data: CreateBaseLostReasonResponse = await response.json();

      if (!data.success) return rejectWithValue(data.message || "Failed to create base lost reason");
      return data;
    } catch (error) {
      return rejectWithValue(error instanceof Error ? error.message : "Unknown error");
    }
  }
);

export const deleteBaseLostReason = createAsyncThunk<
  DeleteBaseLostReasonResponse,
  DeleteBaseLostReasonRequest,
  { rejectValue: string }
>(
  "reason/deleteBaseLostReason",
  async (requestData, { rejectWithValue }) => {
    try {
      const response = await fetch(`${API_BASE_URL}Reason/DeleteBaseLostReason`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(requestData),
      });

      if (!response.ok) throw new Error(`HTTP ${response.status}`);
      const data: DeleteBaseLostReasonResponse = await response.json();

      if (!data.success) return rejectWithValue(data.message || "Failed to delete base lost reason");
      return data;
    } catch (error) {
      return rejectWithValue(error instanceof Error ? error.message : "Unknown error");
    }
  }
);

export const setProjectLostReason = createAsyncThunk<
  SetProjectLostReasonResponse,
  SetProjectLostReasonRequest,
  { rejectValue: string }
>(
  "reason/setProjectLostReason",
  async (requestData, { rejectWithValue }) => {
    try {
      const response = await fetch(`${API_BASE_URL}Reason/SetProjectLostReason`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(requestData),
      });

      if (!response.ok) throw new Error(`HTTP ${response.status}`);
      const data: SetProjectLostReasonResponse = await response.json();

      if (!data.success) return rejectWithValue(data.message || "Failed to set project lost reason");
      return data;
    } catch (error) {
      return rejectWithValue(error instanceof Error ? error.message : "Unknown error");
    }
  }
);